module.exports = __webpack_public_path__ + "static/media/logo-small-blue.d330b801.png";